import React from 'react';

import CkEditor from '../TextEditor/CkEditor';

const AddProject = () => {


    return (
        <>
            <div className='pt-4'>
           
                <div className='bg-white drop-shadow-sm rounded-md mt-8 pb-6'>
                    <h2 className='card-title'> Add Project</h2>
                    <div className='px-10'>
                        <form>
                            <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-5 mb-4'>
                                <div className='space-y-3'>
                                    <div>
                                        <label htmlFor="name">Project name </label>
                                        <input type="text" required />
                                    </div>
                                    <div>
                                        <label htmlFor="name">Client name </label>
                                        <input type="text" />
                                    </div>
                                    <div>
                                        <label htmlFor="email">Location</label>
                                        <input type="text" id='email' />
                                    </div>
                                    <div>
                                        <label htmlFor="llink">Live project link</label>
                                        <input type="text" id='llink' />
                                    </div>
                                    <div>
                                        <label htmlFor="s-link">Source code link</label>
                                        <input type="text" id='s-link' />
                                    </div>
                                    <div>
                                        <label htmlFor="email">Category</label>
                                        <select>
                                            <option>Select...</option>
                                            <option value="mobile-app">Mobile App</option>
                                            <option value="desktop-app">Desktop App</option>
                                            <option value="web-development">Web Development</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='space-y-3'>
                                    <div className='mt-3 sm:mt-0'>
                                        <label htmlFor="date">Date</label>
                                        <input type="date" id='date' />
                                    </div>
                                    <div>
                                        <label htmlFor="email">Upload Image</label>
                                        <input type="file" />
                                    </div>
                                    <div>
                                        <label htmlFor="email">Upload Pdf</label>
                                        <input type="file" />
                                    </div>

                                    <div>
                                        <label htmlFor="email">Project Brief</label>
                                        <CkEditor />
                                    </div>
                                </div>
                            </div>
                            <div className='pt-2'>
                                <button type="submit" className=" btn text-[#444] bg-gray-300 cursor-not-allowed" disabled>Submit</button>
                                <button type="submit" className="ml-4 btn btn-danger">Save as draft</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>

    )
}

export default AddProject;